define.alias("shared/components/shared/post/media/side-library", "media/components/shared/post/media/side-library");